import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";


// Get Table Data
export const BedMasterTableDataAPI = createAsyncThunk("BedMasterTableData", async ({ data }) => {
    const {
        M_WTP_BedMasterID,
        M_WTP_FilterBatteryNoID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_WTP_BedMaster_Select?M_WTP_BedMasterID=${M_WTP_BedMasterID ? M_WTP_BedMasterID : '0'}&M_WTP_FilterBatteryNoID=${M_WTP_FilterBatteryNoID ? M_WTP_FilterBatteryNoID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const BedMasterTableDataSlice = createSlice({
    name: "BedMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BedMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(BedMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(BedMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const BedMasterTableDataReducer = BedMasterTableDataSlice.reducer

export const BedMasterTableExportDataAPI = createAsyncThunk("BedMasterTableExportData", async ({ data }) => {
    const {
        M_WTP_BedMasterID,
        M_WTP_FilterBatteryNoID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_WTP_BedMaster_Select?M_WTP_BedMasterID=${M_WTP_BedMasterID ? M_WTP_BedMasterID : '0'}&M_WTP_FilterBatteryNoID=${M_WTP_FilterBatteryNoID ? M_WTP_FilterBatteryNoID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const BedMasterTableExportDataSlice = createSlice({
    name: "BedMasterTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BedMasterTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(BedMasterTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(BedMasterTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const BedMasterTableExportDataReducer = BedMasterTableExportDataSlice.reducer


export const BedMasterPostDataAPI = createAsyncThunk("BedMasterPostData", async ({ data }) => {
    const {
        M_WTP_BedMasterID,
        M_WTP_FilterBatteryNoID,
        BedNumber,
        M_UserID,     
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_WTP_BedMasterID", M_WTP_BedMasterID);
    formdata.append("M_WTP_FilterBatteryNoID", M_WTP_FilterBatteryNoID);
    formdata.append("BedNumber", BedNumber);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag",Flag);
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    
    fetch(`${BaseUrl}/Master/Post_WEB_M_WTP_BedMaster_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const BedMasterPostDataSlice = createSlice({
    name: "BedMasterPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BedMasterPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(BedMasterPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(BedMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const BedMasterPostDataReducer = BedMasterPostDataSlice.reducer

// -----------------Delete API ---------------

export const BedMasterDeleteAPI = createAsyncThunk("BedMasterDelete", async ({ data }) => {
    const {
        M_WTP_BedMasterID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_WTP_BedMasterID", M_WTP_BedMasterID);
    formdata.append("M_UserID", M_UserID);
    
    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    
    fetch(`${BaseUrl}/Master/WEB_M_WTP_BedMaster_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const BedMasterDeleteSlice = createSlice({
    name: "BedMasterDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BedMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(BedMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(BedMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const BedMasterDeleteReducer = BedMasterDeleteSlice.reducer